export default __webpack_public_path__ + "static/media/empty_km_table_no_distances.78c93aac.png";